import { createFileRoute } from "@tanstack/react-router";
import LTL from "@/pages/services/LTL";

export const Route = createFileRoute("/services/ltl")({ component: LTL });